import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Progress
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { check, updateRequerimentoShapeFile } from "../../Services/RequerimentoShapeFileService";
import { checkKey } from "../../Services/SecurityService";
//import {  } from "../../Services/GeometryShapes";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";
import shp from "shpjs";

let notificationTC = null;

let requerimentos2 = [];
let shapeFile = [];
let totalRequerimentos = 0;
let contRequerimentos = 0;
const LIMITE = 100;


const rootRequerimentos = `${process.env.PUBLIC_URL}/19/shp/requerimentos/`;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      carregarShapes: true,
      next: true,
      clicked: false,
      canceled: false,

      processingStatus: 0,
      processingStatusInfo: 1,
      tempoRestante: '',

      estados: {id:0},
      requerimentoEventos: {id:0},
      requerimentoFase: {id:0},
      substancia: {id:0},
      substanciaUso: {id:0},
      files: [],

      data: {
        id: '',
				name: '',
				ano: '',
				area_ha: '',
				fase: '',
				id_code: '',
				numero: '',
				processo: '',
				subs: '',
				utl_evento: '',
				uso: '',
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: '',
        requerimentoShapeFile: null
      }
    };
    check();

    this.loadShapes = this.loadShapes.bind(this);
    this.loadZipfile = this.loadZipfile.bind(this);
    this.process = this.process.bind(this);
  }

  process(requestList, index, length){
    let inicio = performance.now();
    let fim = 0;
    let diff = 0;
    let tempo = 0;
    let tempoRestante = "";
    // console.log("inicio: " + inicio);
    // console.log(requestList);
    // return;
    updateRequerimentoShapeFile(requestList[index])
    .then(obj => {
      // console.log(obj);
      // console.log(requestList);
      // console.log(index);
      if(obj !== null && obj !== undefined){
        if(obj.erros === null || obj.erros === undefined || obj.erros.length === 0){

          contRequerimentos += requestList[index].requerimentoList.length;
          let processingStatus = (contRequerimentos /  (totalRequerimentos+1)) * 100;

          fim = performance.now();
          diff = fim - inicio;
          tempo = diff * (((totalRequerimentos+1)-contRequerimentos)/LIMITE);
          tempoRestante = util.formatMiliseconds(tempo);

          this.setState({ processingStatus: processingStatus.toFixed(2), tempoRestante });

          if(index === length){
            this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            setTimeout(
              () => this.props.updateTable(false), 
              1000
            );
          }else{
            if(!this.state.canceled){
              this.process(requestList, index+1, length);
            }
          }
          
        }else{
          this.setState({ clicked: false });
          console.log(obj.erros);
          this.show('danger', obj.erros);
        }
      } else {
        this.setState({ clicked: false });
        this.show('danger', this.props.t('forms.dataUpdateError'));
      }
    });
  }

  handleSubmit(e){
    if(this.state.next){
      this.setEntidades();
      //this.setCidades();
    }else{
      this.setState({ clicked: true });
      let requestList = [];
      // let checkMap = new Map();

      totalRequerimentos = requerimentos2.length-1;
      contRequerimentos = -1;
      while(contRequerimentos < totalRequerimentos){
        let request = {
          requerimentoList: [],
          start: (requestList.length === 0)
        };
        if(contRequerimentos < 0){
          contRequerimentos++;
          request.requerimentoList.push(requerimentos2[contRequerimentos]);
          // checkMap.set(requerimentos2[contRequerimentos].processo, requerimentos2[contRequerimentos]);
        }else{
          for(let g = 0; g < LIMITE; g++){
            contRequerimentos++;
            request.requerimentoList.push(requerimentos2[contRequerimentos]);
            // if(checkMap.get(requerimentos2[contRequerimentos].processo) != null){
            //   console.log("Repetido: ");
            //   console.log(requerimentos2[contRequerimentos].processo);
            //   console.log(checkMap.get(requerimentos2[contRequerimentos].processo));
            //   console.log(requerimentos2[contRequerimentos]);
            //   console.log("");
            //   console.log("");
            // }
            // checkMap.set(requerimentos2[contRequerimentos].processo, requerimentos2[contRequerimentos]);
            if(contRequerimentos + 1 > totalRequerimentos){
              break;
            }
          }
        }
        requestList.push(request);
        //console.log(request.length);
      }
      contRequerimentos = 0;//1 + (LIMITE * 175);
      // console.log(requerimentos2.length);
      // console.log(requestList.length);
      this.process(requestList, 0, requestList.length-1);//requestList.length-1
    }
  }

  setEntidades(){
    // console.log("setEntidades");
    // console.log(this.state.estados);
    let teste = [];
    if(requerimentos2 !== null && requerimentos2 !== undefined && requerimentos2.length > 0){
      let total = requerimentos2.length;
      let uf;
      let index = 0;
      let code = "";
      let date = "";
      let requerimentoEvento = {};
      let requerimentoFase = {};
      let requerimentoUso = {};
      let requerimentoSubs = {};
      let fase = "";
      let subs = "";
      let uso = "";
      // let map = new Map();
      for(let i = 0; i < total; i++){
        if(requerimentos2[i].requerimentoShapeFile.estado !== null && 
            requerimentos2[i].requerimentoShapeFile.estado !== undefined && 
            requerimentos2[i].requerimentoShapeFile.estado.id != null && 
            requerimentos2[i].requerimentoShapeFile.estado.id != undefined &&
            requerimentos2[i].requerimentoShapeFile.estado.id > 0){
              requerimentos2[i].estado = requerimentos2[i].requerimentoShapeFile.estado;
        }else{

          uf = requerimentos2[i].requerimentoShapeFile.name.substring(0,2);
          let estado = this.state.estados.get(uf.toLowerCase());
          //if(estado != null && estado != undefined){
          requerimentos2[i].estado = estado;
          requerimentos2[i].requerimentoShapeFile.estado = requerimentos2[i].estado;
          //}
        }

        // map.set(requerimentos2[i].fase, requerimentos2[i].fase);

        date = util.getTextNormalized(requerimentos2[i].utlEvento.replaceAll('�', ''));
        date = date.toLowerCase();
        if(date.includes("dado no cadastrado")){
          requerimentos2[i].evento = this.state.requerimentoEventos.get("0");
          requerimentos2[i].eventoData = null;
        }else{
          date = requerimentos2[i].utlEvento.substring(requerimentos2[i].utlEvento.length-10, requerimentos2[i].utlEvento.length);
          requerimentos2[i].eventoData = date;

          index = requerimentos2[i].utlEvento.indexOf(" -");
          code = requerimentos2[i].utlEvento.substring(0, index);
          requerimentoEvento = this.state.requerimentoEventos.get(code);
          if(requerimentoEvento === null || requerimentoEvento === undefined){
            index = requerimentos2[i].utlEvento.indexOf("- ")+2;
            requerimentos2[i].evento = {
              id: null,
              code: code,
              name: requerimentos2[i].utlEvento.substring(index, requerimentos2[i].utlEvento.length-10).trim(),
              status: "ATIVO",
              deleted: false,
              createdAt: '',
              updatedAt: ''
            }
          }else{
            requerimentos2[i].evento = requerimentoEvento;
          }
        }
        
        fase = "";
        if(requerimentos2[i].fase !== null && requerimentos2[i].fase !== undefined && requerimentos2[i].fase.length > 0){
          fase = util.getTextNormalized(requerimentos2[i].fase.replaceAll('�', ''));
          requerimentoFase = this.state.requerimentoFase.get(fase.toLowerCase());
          if(requerimentoFase === null || requerimentoFase === undefined){
            requerimentos2[i].fase = {
              id: null,
              code: null,
              name: requerimentos2[i].fase,
              nameCarga: fase.toLowerCase(),
              status: "ATIVO",
              deleted: false,
              createdAt: '',
              updatedAt: ''
            }
          }else{
            requerimentos2[i].fase = requerimentoFase;
          }       
        }else{
          requerimentos2[i].fase = requerimentoFase = this.state.requerimentoFase.get("Dado No Cadastrado".toLowerCase());
        }

        subs = util.getTextNormalized(requerimentos2[i].subs.replaceAll('�', ''));
        requerimentoSubs = this.state.substancia.get(subs.toLowerCase());
        if(requerimentoSubs === null || requerimentoSubs === undefined){
          requerimentos2[i].substancia = {
            id: null,
            code: null,
            name: requerimentos2[i].subs,
            nameCarga: subs.toLowerCase(),
            status: "ATIVO",
            deleted: false,
            createdAt: '',
            updatedAt: ''
          }
        }else{
          requerimentos2[i].substancia = requerimentoSubs;
        }

        uso = util.getTextNormalized(requerimentos2[i].uso.replaceAll('�', ''));
        requerimentoUso = this.state.substanciaUso.get(uso.toLowerCase());
        if(requerimentoUso === null || requerimentoUso === undefined){
          requerimentos2[i].substanciaUso = {
            id: null,
            code: null,
            name: requerimentos2[i].uso,
            nameCarga: uso.toLowerCase(),
            status: "ATIVO",
            deleted: false,
            createdAt: '',
            updatedAt: ''
          }
        }else{
          requerimentos2[i].substanciaUso = requerimentoUso;
        }
        

        // if(i < 10){
        //   teste.push(requerimentos2[i]);
        // }else if(i === 10){
        //   console.log(teste);
        // }
      }
      // console.log(map);
    }
    
    this.setState({next: false});
  }

  loadShapes(){
    //this.loadFileNames("g");
    //this.loadFileNames("r");
    let total = this.state.files.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        this.loadZipfile(this.state.files[i]);

        let processingStatus = ((i+1) /  total) * 100;
        this.setState({ carregarShapes: false, processingStatus: processingStatus.toFixed(2) });
      }
      setTimeout(
        () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo+1 }), 
        1000
      );
    }
  }

  loadZipfile(file) {
    let path = rootRequerimentos.concat(file.name).concat(".zip");
    
    try {
      shp(path).then(function (shapes) {
        console.log(shapes);
        let list = [];
        if(shapes.length != undefined && shapes.length != null && shapes.length > 0){
          list = shapes;
        }else{
          list.push(shapes);
        }
        //console.log(index);
        //console.log(list);
        //console.log(list.length);
        
        let totalFeatures = 0;
        let filename = "";
        for(let dta = 0; dta < list.length; dta++){
          let data = list[dta];
          filename = data.fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          totalFeatures = data.features.length;
          
          // console.log(data);
          // console.log(filename);
          // console.log(totalFeatures);
          let cont = 0;
          for(let i = 0; i < totalFeatures; i++){
            cont++;
            let geometry = {
              id: '',
              processo: '',
              status: "ATIVO",
              deleted: false,
              bbox: null,
              coordinates: null,
              coordinatesMulti: null,
              bboxList: [],
              coordinatesList: [],
              coordinatesMultiList: []
            };
            
            let properties = data.features[i].properties;
            // if(i == 0){
            //   console.log(properties);
            // }
            if(properties != null && properties != undefined){
              let requerimento = {
                id: '',
                name: properties.NOME,
                ano: properties.ANO,
                areaHA: properties.AREA_HA,
                fase: properties.FASE,
                idCode: properties.ID,
                numero: properties.NUMERO,
                processo: properties.PROCESSO,
                subs: properties.SUBS,
                utlEvento: properties.ULT_EVENTO,
                eventoData: '',
                evento: '',
                uso: properties.USO,
                cidade: null,
                estado: properties.UF,
                uf: properties.UF.toLowerCase(),
                color: '',
                colorRGB: '',
                cidadeDivisa: '',
                sync: false,
                status: "ATIVO",
                deleted: false,
                followed: false,
                createdAt: '',
                updatedAt: '',
                requerimentoShapeFile: {
                  id: file.id,
                  name: filename,
                  filename: file.name + ".zip",
                  size: file.size,
                  requerimentos: totalFeatures,
                  requerimentosLidas: 0,
                  cidade: file.cidade,
                  estado: file.estado,
                  extension: file.extension,
                  type: file.type,
                  statusLoad: file.statusLoad,
                  deleted: file.deleted,
                  createdAt: file.createdAt,
                  updatedAt: file.updatedAt
                }
              };
              geometry.processo = requerimento.processo;
              
              let bboxList = data.features[i].geometry.bbox;
              // if(i == 0){
              //   console.log(bboxList);
              // }
              if(bboxList != null && bboxList != undefined && bboxList.length > 0){
                for(let m = 0; m < bboxList.length; m += 2){
                  geometry.bboxList.push({
                    lat: bboxList[(m+1)],
                    lng: bboxList[m]
                  });
                }
              }
              //console.log(bboxList);

              let type = data.features[i].geometry.type;
              let coordinatesList = data.features[i].geometry.coordinates;
              // if(i == 0){
              //   console.log(coordinatesList);
              // }
              if(coordinatesList != null && coordinatesList != undefined && coordinatesList.length > 0){
                if(type === "Polygon"){
                  for(let j = 0; j < coordinatesList.length; j++){
                    let coordinates = coordinatesList[j];
                    for(let m = 0; m < coordinates.length; m++){
                      geometry.coordinatesList.push({
                        lat: coordinates[m][1],
                        lng: coordinates[m][0]
                      });
                    }
                  }
                }else if(type === "MultiPolygon"){
                  for(let j = 0; j < coordinatesList.length; j++){
                    let coordinatesAux = coordinatesList[j];
                    let coordinates = coordinatesAux[0];
                    let coordList = [];
                    for(let m = 0; m < coordinates.length; m++){
                      coordList.push({
                        lat: coordinates[m][1],
                        lng: coordinates[m][0]
                      });
                    }
                    geometry.coordinatesMultiList.push(coordList);
                  }
                }
              }
              requerimento.geometryShapeRequerimento = [];
              requerimento.geometryShapeRequerimento.push(geometry);

              requerimentos2.push(requerimento);
              // if(requerimento.idCode === "{C8098020-59C5-4586-87D8-C9DC0854A191}"){
              //   console.log(requerimento);
              //   requerimentos2.push(requerimento);//mccosta remover teste
              // }
              // if(requerimentos2.length < 5){
              //   // console.log(requerimento);
              //   requerimentos2.push(requerimento);//mccosta remover teste
              // }
            }else{
              console.log("error");
              console.log(data.features[i]);
            }
          }
          // console.log(cont);
        }        
      });
    } catch (err) {
      console.log(err);
    }
  }
  
  loadData(files, estados, requerimentoEventos, requerimentoFase, substancia, substanciaUso) {
    if(files !== undefined && files !== null && files.length > 0 && this.state.files.length === 0){
      this.setState({ files }, () => {});
    }
    if(estados !== undefined && estados !== null && this.state.estados.id !== undefined){
      this.setState({ estados }, () => {});
    }
    if(requerimentoEventos !== undefined && requerimentoEventos !== null && this.state.requerimentoEventos.id !== undefined){
      this.setState({ requerimentoEventos }, () => {});
    }
    if(requerimentoFase !== undefined && requerimentoFase !== null && this.state.requerimentoFase.id !== undefined){
      this.setState({ requerimentoFase }, () => {});
    }
    if(substancia !== undefined && substancia !== null && this.state.substancia.id !== undefined){
      this.setState({ substancia }, () => {});
    }
    if(substanciaUso !== undefined && substanciaUso !== null && this.state.substanciaUso.id !== undefined){
      this.setState({ substanciaUso }, () => {});
    }
  }

  countPolygon(type, list){
    let total = 0;
    if(type === "P"){
      total = list.length;
    }else{
      for(let i = 0; i < list.length; i++){
        total += list[i].length;
      }
    }
    return total;
  }

  componentDidMount() {
    checkKey("MENU_REQUIREMENT_SHP_PROCESSING");
    
    const { files, estados, requerimentoEventos, requerimentoFase, substancia, substanciaUso} = this.props;
    this.loadData(files, estados, requerimentoEventos, requerimentoFase, substancia, substanciaUso);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);

    // this.findAllGeometryShapesByGeologia_teste("K1i");
  }

  componentDidUpdate(props, state) {
    if(props.files !== this.props.files || props.estados !== this.props.estados || 
        props.requerimentoEventos !== this.props.requerimentoEventos || props.requerimentoFase !== this.props.requerimentoFase || 
        props.substancia !== this.props.substancia || props.substanciaUso !== this.props.substanciaUso){
      this.loadData(this.props.files, this.props.estados, this.props.requerimentoEventos, this.props.requerimentoFase, this.props.substancia, this.props.substanciaUso);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  clear(canceled){
    const data = { ...this.state.data }
    data['id'] = '';
    data['name'] = '';
    data['ano'] = '';
    data['area_ha'] = '';
    data['fase'] = '';
    data['id_code'] = '';
    data['numero'] = '';
    data['processo'] = '';
    data['subs'] = '';
    data['utl_evento'] = '';
    data['uso'] = '';
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    data['requerimentoShapeFile'] =  null;
    this.setState({ 
      data,
      estados: {},
      files: [],
      canceled
    }, () => {});
  }

  cancel(event) {
    this.clear(true);
    this.props.updateTable(false);
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    const { files, carregarShapes, clicked, processingStatus, processingStatusInfo, tempoRestante } = this.state;


    // console.log(this.state.requerimentoEventos);
    // console.log(this.state.substancia);
    // console.log(this.state.substanciaUso);


    let requerimentoShapeFile = [];
    if(this.state.next){
      let total = files.length;
      if(total > 0){
        for(let i = 0; i < total; i++){
          requerimentoShapeFile.push(
            <div key={"divshapes_"+i} className='form__form-inline' style={{width: '100%', borderBottom: '1px solid #cccccc'}}>
              <label 
                key={"labelshapes_"+i}
                style={{margin: 0, width: '100%'}}>
                {files[i].name}
              </label>
              <label 
                key={"labelshapes2_"+i}
                style={{margin: 0, }}>
                {t('forms.requerimentos')}
              </label>
            </div>
          );
        }
      }
    }else{
      let exists = false;
      shapeFile = [];
      let totalSimbs = requerimentos2.length;
      let total = requerimentos2.length;
      let maxSimbs = 50;
      if(total > maxSimbs){
        total = maxSimbs;
      }
      if(total > 0){
        for(let i = 0; i < total; i++){
          if(shapeFile.length === 0){
            let shp = {
              name: requerimentos2[i].requerimentoShapeFile.name,
              requerimentos: []
            }
            if(requerimentos2[i].geometryShapeRequerimento[0].coordinatesList.length > 0){
              shp.requerimentos.push(requerimentos2[i].processo + " (Polygon coords: " + this.countPolygon("P", requerimentos2[i].geometryShapeRequerimento[0].coordinatesList) + ")");
            }else{
              shp.requerimentos.push(requerimentos2[i].processo + " (MultiPolygon coords: " + this.countPolygon("M", requerimentos2[i].geometryShapeRequerimento[0].coordinatesMultiList) + ")");
            }
            shapeFile.push(shp);
          }else{
            exists = false;
            for(let j = 0; j < shapeFile.length; j++){
              // console.log(requerimentos2[i].requerimentoShapeFile.name + " === " + shapeFile[j].name);
              if(requerimentos2[i].requerimentoShapeFile.name === shapeFile[j].name){
                if(requerimentos2[i].geometryShapeRequerimento[0].coordinatesList.length > 0){
                  shapeFile[j].requerimentos.push(requerimentos2[i].processo + " (Polygon coords: " + this.countPolygon("P", requerimentos2[i].geometryShapeRequerimento[0].coordinatesList) + ")");
                }else{
                  shapeFile[j].requerimentos.push(requerimentos2[i].processo + " (MultiPolygon coords: " + this.countPolygon("M", requerimentos2[i].geometryShapeRequerimento[0].coordinatesMultiList) + ")");
                }
                exists = true;
                shapeFile[j].requerimentos = shapeFile[j].requerimentos.sort((a, b) => (a > b) ? 1 : -1);
                break;
              }
            }
            if(!exists){
              // console.log("diff");
              let shp = {
                name: requerimentos2[i].requerimentoShapeFile.name,
                requerimentos: []
              }
              if(requerimentos2[i].geometryShapeRequerimento[0].coordinatesList.length > 0){
                shp.requerimentos.push(requerimentos2[i].processo + " (Polygon coords: " + this.countPolygon("P", requerimentos2[i].geometryShapeRequerimento[0].coordinatesList) + ")");
              }else{
                shp.requerimentos.push(requerimentos2[i].processo + " (MultiPolygon coords: " + this.countPolygon("M", requerimentos2[i].geometryShapeRequerimento[0].coordinatesMultiList) + ")");
              }
              shapeFile.push(shp);
            }
          }
        }
        
        for(let i = 0; i < shapeFile.length; i++){
          let simbs = [];
          for(let j = 0; j < total; j++){
            simbs.push(
              <div key={"labelshapesdiv_"+i+"_"+j} className='form__form-inline' 
                style={{width: 'auto', backgroundColor: 'rgb(190 255 190 / 35%)', border: '1px solid', 
                borderColor: 'rgb(36 140 36 / 35%)', paddingLeft: '3px', paddingRight: '3px', marginRight: '10px', marginBottom: '10px' }}>
                <label 
                  key={"labelshapes2_"+i}
                  style={{margin: 0, }}>
                  {shapeFile[i].requerimentos[j]}
                </label>
              </div>
            );
          }
          if(totalSimbs > maxSimbs){
            simbs.push(
              <div key={"labelshapesdivtotal_"+i} className='form__form-inline' 
                style={{width: 'auto', backgroundColor: 'rgb(190 255 190 / 35%)', border: '1px solid', 
                borderColor: 'rgb(36 140 36 / 35%)', paddingLeft: '3px', paddingRight: '3px', marginRight: '10px', marginBottom: '10px' }}>
                <label 
                  key={"labelshapes2total_"+i}
                  style={{margin: 0, }}>
                  {" + " + (totalSimbs-maxSimbs) + " " + t('forms.processos')}
                </label>
              </div>
            );
          }

          requerimentoShapeFile.push(
            <div key={"divshapes_"+i} className="form__form-inline" 
                  style={{height: 'auto', width: '100%', borderBottom: '1px solid #cccccc'}}>
              <label 
                key={"labelshapes_"+i}
                style={{margin: 0, width: '100%'}}>
                {shapeFile[i].name + ": " + requerimentos2.length + " " + t('forms.requerimentos')}
              </label>
              <div key={"divshapes_simbsProcessos"+i} className="form__form-group-field" 
                  style={{width: '100%', display: 'flow-root', flexWrap: 'wrap'}}>
                    {t('forms.processos')}
              </div>
              <div key={"divshapes_simbs"+i} className="form__form-group-field" 
                  style={{width: '100%', display: 'flow-root', flexWrap: 'wrap'}}>
                    {simbs}
              </div>
            </div>
          );
        }
      }
    }

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.toProcess')}</h3>
            </div>
            <div className="form">

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.processingStatus') + " - " + t('forms.processingStatusInfo_requirements_'+processingStatusInfo) + ": " + processingStatus + " % (" + t('forms.timeLeft') + ": " + tempoRestante + ")"} 
                </span>
                <div key="div1" className="progress-wrap progress-wrap--big">
                  <Progress key="progress1" animated value={processingStatus} />
                </div>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px'}}>
                  
                  {requerimentoShapeFile}

                </div>
              </div>
              
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit"
                  onClick={e => this.loadShapes()}
                  disabled={!carregarShapes}>
                  {t('forms.loadShapes')}
                </Button>
                <Button color="primary" type="submit"
                  onClick={e => this.handleSubmit(e)}
                  disabled={carregarShapes || clicked}>
                  {this.state.next ? t('forms.synchronize') : t('forms.save') }
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(CrudEdit);
